import { FormattedMessage } from 'react-intl';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/registry/ui/Tabs';
import { servicePlanItemsMessages } from 'src/features/servicePlanItems/utils/messages';
import ServicePlanItemsTable from 'src/features/servicePlanItems/components/ServicePlanItemsTable';
import { servicePlanTermsMessages } from 'src/features/servicePlanTerms/utils/messages';
import ServicePlanTermsTable from 'src/features/servicePlanTerms/components/tables/ServicePlanTermsTable';

type ServicePlanDashboardTablesProps = {
    isServicePlanActive?: boolean;
};

const ServicePlanDashboardTables = ({ isServicePlanActive }: ServicePlanDashboardTablesProps) => {
    return (
        <div className="grid flex-3 grid-cols-1">
            <Tabs defaultValue="items">
                <TabsList>
                    <TabsTrigger value="items">
                        <FormattedMessage {...servicePlanItemsMessages.servicePlanItems} />
                    </TabsTrigger>
                    <TabsTrigger value="terms">
                        <FormattedMessage {...servicePlanTermsMessages.servicePlanTerms} />
                    </TabsTrigger>
                </TabsList>
                <TabsContent value="items">
                    <ServicePlanItemsTable isServicePlanActive={isServicePlanActive} />
                </TabsContent>
                <TabsContent value="terms">
                    <ServicePlanTermsTable isServicePlanActive={isServicePlanActive} />
                </TabsContent>
            </Tabs>
        </div>
    );
};

export default ServicePlanDashboardTables;
